





























































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ITaxTemplatesProvider,
  ITaxTemplatesProviderMethods
} from "@/models/providers/tax";

@Component
export default class TaxTemplatesTableView extends Vue {
  // Inject

  @Inject({ from: "taxTemplatesProvider" })
  public taxTemplatesProvider!: () => ITaxTemplatesProvider;

  @Inject({ from: "taxTemplatesProviderMethods" })
  public $taxTemplatesMethods!: ITaxTemplatesProviderMethods;

  // Computed

  public get $taxTemplatesData() {
    return this.taxTemplatesProvider();
  }

  public get templateItems() {
    const { data, total } = this.$taxTemplatesData.table;
    if (total) return data;
    return new Array(4);
  }

  public get showEmptyState() {
    const { loading, total } = this.$taxTemplatesData.table;
    return !loading && !total;
  }

  public get showSkeletons() {
    const { loading, total } = this.$taxTemplatesData.table;
    return loading || !total;
  }
}
